import { analytics } from 'libs';

const AdBanner = () => (
  <a
    className="ad-banner"
    href="https://www.haventreebank.com/en-CA/promotions/submit-and-win?utm_source=Lendesk&utm_medium=banner"
    onClick={() => analytics.promotions.adBannerClick('Haventree Bank', 'Alt Lending')}
    rel="noopener noreferrer"
    target="_blank"
  >
    <picture>
      <source media="(max-width: 767px)" srcSet="/images/haventree-mobile-banner-26-07-10.png" />
      <img alt="Advertisement Banner" src="/images/haventree-desktop-banner-26-07-10.png" />
    </picture>
  </a>
);

export default AdBanner;
